import FastMarquee from "react-fast-marquee";
import { Asterisk } from "lucide-react";
import { useApp } from "../context/AppContext";

export const Marquee = () => {
  const { t } = useApp();
  return (
    <div className="border-b border-border py-8 md:py-10" data-testid="destination-marquee">
      <FastMarquee speed={30} gradient={false} pauseOnHover>
        {t.marquee.map((d, i) => (
          <span key={d} className="flex items-center">
            <span
              className={`font-display text-4xl font-semibold uppercase tracking-tight md:text-6xl ${
                i % 2 === 1 ? "text-transparent" : "text-foreground/90"
              }`}
              style={i % 2 === 1 ? { WebkitTextStroke: "1.5px hsl(var(--foreground))" } : undefined}
            >
              {d}
            </span>
            <Asterisk className="mx-8 h-8 w-8 text-primary md:mx-12 md:h-10 md:w-10" strokeWidth={1.5} />
          </span>
        ))}
      </FastMarquee>
    </div>
  );
};
